/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

// deep clone state
import cloneDeep from 'lodash/cloneDeep';

export function cloneState(state) {
    return cloneDeep(state);
}
